module.exports = __webpack_public_path__ + "img/sheraton-pool.8783e6b3.jpg";